<div class="relative" libClickOutSide (clickOutside)="onClickOutside()">
  @if (showDropdown()) {
    <div class="absolute bottom-full mb-sm grouped-button-dropdown-menu">
      @for (action of config().actions; track action.value) {
        <div class="grouped-button-dropdown-item mb-lg">
          <button
            type="button"
            [id]="action.value"
            (click)="handleActionClick(action.value)"
            class="px-lg py-sm font-medium text-red-600 bg-red-50 cursor-pointer rounded-md text-sm shadow-sm">
            <div class="flex items-center gap-sm">
              @switch (action.value) {
                @case ('reject') {
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.9668 4.16602L16.6327 15.8319"
                      stroke="#EF4444"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M4.96498 15.8319L16.6309 4.16602"
                      stroke="#EF4444"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                }
                @case ('send_back') {
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.6314 6.95084V13.0509C18.6314 14.3009 17.2731 15.0842 16.1897 14.4592L13.5481 12.9425L10.9064 11.4175C10.7397 11.3175 10.6064 11.2092 10.498 11.0759V8.94252C10.6064 8.80919 10.7397 8.70085 10.9064 8.60085L13.5481 7.07584L16.1897 5.55919C17.2731 4.91753 18.6314 5.70084 18.6314 6.95084Z"
                      stroke="#DC2626"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M10.4984 6.95084V13.0509C10.4984 14.3009 9.1401 15.0842 8.05677 14.4592L5.41512 12.9425L2.77344 11.4175C1.6901 10.7925 1.6901 9.23419 2.77344 8.60085L5.41512 7.07584L8.05677 5.55919C9.1401 4.91753 10.4984 5.70084 10.4984 6.95084Z"
                      stroke="#EF4444"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                }
                @case ('send_forward') {
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.96484 6.95084V13.0509C1.96484 14.3009 3.32317 15.0842 4.4065 14.4592L7.04818 12.9425L9.68983 11.4175C9.8565 11.3175 9.98985 11.2092 10.0982 11.0759V8.94252C9.98985 8.80919 9.8565 8.70085 9.68983 8.60085L7.04818 7.07584L4.4065 5.55919C3.32317 4.91753 1.96484 5.70084 1.96484 6.95084Z"
                      stroke="#DC2626"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M10.0996 6.95084V13.0509C10.0996 14.3009 11.4579 15.0842 12.5413 14.4592L15.1829 12.9425L17.8246 11.4175C18.9079 10.7925 18.9079 9.23419 17.8246 8.60085L15.1829 7.07584L12.5413 5.55919C11.4579 4.91753 10.0996 5.70084 10.0996 6.95084Z"
                      stroke="#EF4444"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                }
              }
              <span>{{ action.label }}</span>
            </div>
          </button>
        </div>
      }
    </div>
  }

  <div
    class="flex items-center justify-center gap-lg text-base cursor-pointer bg-red-50 text-red-600 rounded-md shadow-sm px-md py-sm font-medium"
    (click)="toggleDropdown()"
    [class.dropdown-open]="showDropdown()">
    <span>{{ config().mainLabel }}</span>
    <!-- Separator line -->
    <svg
      width="2"
      height="22"
      class="grouped-button-separator"
      viewBox="0 0 2 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <line
        x1="0.898438"
        y1="1"
        x2="0.898438"
        y2="21"
        stroke="#EF4444"
        stroke-linecap="round" />
    </svg>
    <!-- Dropdown arrow -->
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="grouped-button-arrow">
      <path
        d="M16.8516 7.31152C16.9304 7.23276 17.0666 7.23287 17.1455 7.31152C17.2244 7.39044 17.2244 7.52651 17.1455 7.60547L11.7129 13.0391C11.352 13.3999 10.8751 13.584 10.3984 13.584C9.92188 13.5839 9.44576 13.3999 9.08496 13.0391L3.65137 7.60547C3.57278 7.52647 3.57254 7.39035 3.65137 7.31152C3.7302 7.23269 3.86631 7.23293 3.94531 7.31152L9.37891 12.7451C9.94157 13.3078 10.8552 13.3077 11.418 12.7451L16.8516 7.31152Z"
        stroke="#DC2626"
        stroke-width="0.833333" />
    </svg>
  </div>
</div>
